import { Injectable } from '@angular/core';
import {
	GenericPartyOnboardingResponse,
	PatchPartyOnboardingRequest,
	PostPartyOnboardingRequest
} from '../../models/api.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { GlobalConfigService } from '@shared/utils/global-config.service';
import { PARTY_ONBOARDING_SERVICE_API_ROUTES } from './party-onboarding-api-routes';
import { v4 as uuid } from 'uuid';
import { environment } from '@environments/environment';

const BASIC_AUTH_VALUE = btoa(
	`${environment.muleExperienceAppID}:${environment.muleExperienceAppPassword}`
);
@Injectable({
	providedIn: 'root'
})
export class PartyOnboardingApiService {
	constructor(
		private http: HttpClient,
		private translateService: TranslateService
	) {}

	// TODO: Switch to HTTPInterceptor
	private getHttpOpts(tmxFlag: boolean): { headers: HttpHeaders } {
		const headers: any = {
			'Content-Type': 'application/json',
			Authorization: `Basic ${BASIC_AUTH_VALUE}`,
			correlationId: uuid(),
			channel: 'WEB',
			language: this.translateService.currentLang
		};

		if (tmxFlag) {
			headers.tmSessionId = GlobalConfigService.sessionId;
		}

		return {
			headers: new HttpHeaders(headers)
		};
	}

	public postPartyOnboardingExecution(
		postPartyOnboardingRequest: PostPartyOnboardingRequest
	): Observable<GenericPartyOnboardingResponse> {
		return this.http.post<GenericPartyOnboardingResponse>(
			PARTY_ONBOARDING_SERVICE_API_ROUTES.partyOnboardingExecution(),
			postPartyOnboardingRequest,
			this.getHttpOpts(true)
		);
	}

	public patchPartyOnboardingExecution(
		patchPartyOnboardingRequest: PatchPartyOnboardingRequest
	): Observable<GenericPartyOnboardingResponse> {
		return this.http.patch<GenericPartyOnboardingResponse>(
			PARTY_ONBOARDING_SERVICE_API_ROUTES.partyOnboardingExecution(),
			patchPartyOnboardingRequest,
			this.getHttpOpts(false)
		);
	}

	public deletePartyOnboardingExecution(
		executionId: string,
		partyIdValue: string
	): Observable<GenericPartyOnboardingResponse> {
		const deleteHttpOpts = {
			headers: new HttpHeaders({
				partyId: partyIdValue
			})
		};
		return this.http.delete<GenericPartyOnboardingResponse>(
			PARTY_ONBOARDING_SERVICE_API_ROUTES.deletePartyOnboardingExecution(
				executionId
			),
			deleteHttpOpts
		);
	}

	public submitPartyOnboardingExecution(
		executionId: string
	): Observable<GenericPartyOnboardingResponse> {
		return this.http.post<GenericPartyOnboardingResponse>(
			PARTY_ONBOARDING_SERVICE_API_ROUTES.submitPartyOnboardingExecution(
				executionId
			),{},
			this.getHttpOpts(false)
		);
	}
}
